import { TRootState } from "Redux/Reducers";

export const getLastAppUserId = (state: TRootState) => state.appUser.lastUpdateId;
